interface PositionProps {
  y: number
  alignment: string
  yScaleID: string
}

interface LabelProps {
  text: string
  backgroundColor: string
}

/**
 * Creates a configs object that adds a text annotation to a ChartJS graph.
 * The configs object must be added to `plugins.annotation.annotations` in the graph options.
 *
 * The text box is a line annotation with a label, where the line itself is transparent.
 * @returns the configs object
 */
export const createHorizontalAnnotation = (positionProps: PositionProps, labelProps: LabelProps): any => {
  const { y, alignment, yScaleID } = positionProps
  const { text, backgroundColor } = labelProps
  return {
    type: 'line',
    scaleID: yScaleID,
    value: y,
    borderWidth: 0,
    borderColor: 'rgba(0,0,0,0)', // Make the line transparent
    label: {
      content: text,
      display: true,
      position: alignment,
      backgroundColor
    }
  }
}
